import React from "react";
import { Link } from "react-router-dom";
import { Mail, MapPin, Phone } from "lucide-react";

export const Footer = () => {
  return (
    <footer data-testid="site-footer" className="bg-[#12495B] text-[#FDFBF7]/80 mt-24">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 py-16 grid gap-10 md:grid-cols-3">
        <div>
          <div className="flex items-center gap-3 mb-4">
            <span className="w-10 h-10 rounded-full bg-[#FDFBF7] text-[#12495B] flex items-center justify-center font-display text-xl">68</span>
            <span className="font-display text-lg leading-tight text-white">Pour une Alsace forte dans une France qui respecte ses territoires</span>
          </div>
          <p className="mt-3 text-sm leading-relaxed max-w-xs">Élections sénatoriales · Haut-Rhin · 27 septembre 2026</p>
        </div>

        <div>
          <h4 className="text-white font-semibold mb-4 text-sm tracking-[0.2em] uppercase">Navigation</h4>
          <ul className="space-y-2 text-sm">
            <li><Link to="/programme" className="hover:text-[#F5C518] transition-colors duration-300">3 priorités</Link></li>
            <li><Link to="/lettre" className="hover:text-[#F5C518] transition-colors duration-300">Lettre de candidature</Link></li>
            <li><Link to="/profession-de-foi" className="hover:text-[#F5C518] transition-colors duration-300">Profession de foi</Link></li>
            <li><Link to="/actualites" className="hover:text-[#F5C518] transition-colors duration-300">Actualités</Link></li>
            <li><Link to="/contact" className="hover:text-[#F5C518] transition-colors duration-300">Contact</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="text-white font-semibold mb-4 text-sm tracking-[0.2em] uppercase">Contact</h4>
          <ul className="space-y-3 text-sm">
            <li className="flex items-center gap-3"><MapPin size={16} className="text-[#F5C518]" /> Haut-Rhin (68)</li>
            <li className="flex items-center gap-3"><Mail size={16} className="text-[#F5C518]" /> alsaceforte@mail.fr</li>
            <li className="flex items-center gap-3">
              <Phone size={16} className="text-[#F5C518]" />
              <a
                href="https://docs.google.com/forms/d/e/1FAIpQLSfSIK4POVWHP58Gqtg4q8-vJDVwgrsp3VWKxbIFJux7ubpyWg/viewform?usp=header"
                target="_blank"
                rel="noreferrer"
                data-testid="footer-rdv-link"
                className="hover:text-[#F5C518] transition-colors duration-300"
              >
                Demander une rencontre ou un RDV téléphonique
              </a>
            </li>
          </ul>
        </div>
      </div>
      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-5 sm:px-8 py-6 text-xs text-[#FDFBF7]/50 flex flex-col sm:flex-row justify-between gap-2">
          <span>© 2026 Pour une Alsace forte — Tous droits réservés.</span>
          <span>Mentions légales · Site de démonstration</span>
        </div>
      </div>
    </footer>
  );
};
